import { render } from "./index-loader.vue?vue&type=template&id=1f74e677&scoped=true"
import script from "./index-loader.vue?vue&type=script&lang=js"
export * from "./index-loader.vue?vue&type=script&lang=js"

import "./index-loader.vue?vue&type=style&index=0&id=1f74e677&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f74e677"]])

export default __exports__